export class SidebarClass {
	sidebarToggle: HTMLElement = document.querySelector("[data-sidebar-toggle]");
	sidebar: HTMLElement = document.querySelector("[data-sidebar]");
	sidebarListList: NodeList = document.querySelectorAll("[data-sidebar] li");
	sidebarListArray: HTMLElement[] = Array.prototype.slice.call(this.sidebarListList);
	activeClass: string = 'is-active';

	constructor() {
		this.menuHandler()
	}
	private menuHandler = () => {
		this.sidebarToggle.addEventListener("click", (e: Event) => {
			(e.target as HTMLElement).classList.toggle(this.activeClass)
			this.sidebar.classList.toggle(this.activeClass)
		});
		this.sidebarListArray.forEach((elem) => {
			elem.addEventListener("click", () => {
				this.sidebar.classList.remove(this.activeClass);
				this.sidebarToggle.classList.remove(this.activeClass);
			});
		});
	}
}
